<template>
  <div>
    <v-progress-circular v-if="loading" size="20" indeterminate color="rgba(0, 0, 0, 0.87)" />
    <div v-else>
      <v-simple-table dense class="table-indqual-result">
        <template v-slot:default>
          <thead>
            <tr>
              <th>INDICADOR</th>
              <th>MÊS</th>
              <th class="text-right">TOTAL CONJ</th>
              <th class="text-right">LINHAS IMPORTADAS</th>
              <th class="text-right">ATUALIZADO EM</th>
            </tr>
          </thead>
          <tbody></tbody>
          <tbody>
            <tr v-for="(item, j) in resultado" :key="j" :class="j % 2 === 1 ? 'zebra1' : ''">
              <td>{{ item.sigla_indice }}</td>
              <td>{{ item.mes | addLeadingZero }}</td>
              <td
                class="text-right"
                style="font-size: 12px !important"
                :class="{
                  'status-indqual-erro': item.total_conj === 0 || item.total_conj !== item.total_linhas_indicadores
                }"
              >
                {{ item.total_conj }}
              </td>
              <td
                class="text-right"
                style="font-size: 12px !important"
                :class="{
                  'status-indqual-ok': item.total_linhas_indicadores > 0 && item.total_conj === item.total_linhas_indicadores,
                  'status-indqual-erro': item.total_linhas_indicadores <= 0 || item.total_conj !== item.total_linhas_indicadores
                }"
              >
                {{ item.total_linhas_indicadores }}
              </td>
              <td class="text-right">
                {{ item.ultima_atualizacao_em | parseToDateTimeBR }}
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </div>
  </div>
</template>

<script>
  import ValidacoesIndqualService from '@/services/ValidacoesIndqualService';

  export default {
    name: 'TabelaResumoImportacoesIndicadoresDecFecNuc',
    props: {
      bdgdVersao: {
        type: Object,
        required: true
      }
    },
    data: () => ({
      loading: false,
      resultado: []
    }),
    mounted() {
      this.getResumoImportacoesIndicadoresDecFecNuc();
    },
    methods: {
      getResumoImportacoesIndicadoresDecFecNuc() {
        this.loading = true;
        ValidacoesIndqualService.getResumoImportacoesIndicadoresDecFecNuc(this.bdgdVersao.id)
          .then((response) => {
            this.resultado = response.data;
          })
          .catch((err) => {
            console.log('Erro: ', err);
            this.$toast.error('Erro ao buscar o resumo de importações dos indicadores DEC/FEC/NUC.', '', {
              position: 'topRight'
            });
          })
          .finally(() => (this.loading = false));
      }
    },
    watch: {
      bdgdVersao() {
        this.getResumoImportacoesIndicadoresDecFecNuc();
      }
    }
  };
</script>
